import { Pipe, PipeTransform } from '@angular/core';
import { isNil, startCase, toLower } from 'lodash';
import { NOT_AVAILABLE, UNKNOWN } from '../../common/constants/template.constant';
import {
  ImmutableMonitoringListTitleFilter,
  RecordTypeFilter,
  isFilterValueSentenceCase,
  isFilterValueUpperCase,
  recordTypeFilterMap,
  RecordTypeFilterKey,
} from '../../store/constants';
import { customFilterTitles } from '../../store/state/monitoring/transport/constants/transport-list.constant';
import { SentenceCasePipe } from './sentence-case.pipe';
import { FilterValueSentenceCaseUnionType, FilterValueUpperCaseUnionType } from '../../store/models';
import { customAcronymTooltips } from '../constants';

@Pipe({
    name: 'monitoringFilterAdjustUiPipe',
    standalone: false
})
export class MonitoringFilterAdjustUiPipe implements PipeTransform {
  constructor(private sentenceCasePipe: SentenceCasePipe) {}

  transform(
    value: string | number | RecordTypeFilter,
    filterTitle?: ImmutableMonitoringListTitleFilter | string,
  ): string {
    if (typeof value === 'number') {
      return String(value);
    }
    if (typeof value !== 'string') {
      return recordTypeFilterMap
        .get(filterTitle)
        .reduce((accumulator: string, currentValue: RecordTypeFilterKey, currentIndex: number) => {
          return isNil(value[currentValue])
            ? `${accumulator}`
            : currentIndex === 0
            ? `${value[currentValue]}`
            : `${accumulator} | ${value[currentValue]}`;
        }, '');
    } else {
      switch (true) {
        case value === UNKNOWN:
          return NOT_AVAILABLE;
        case this.isFilterTitleSentenceCase(value):
          return this.sentenceCasePipe.transform(value);
        case this.isFilterTitleCustomCase(value):
          return customFilterTitles[value];
        case this.isAcronymCustom(value):
          return customAcronymTooltips[value];
        case this.isPipeNotApplicable(value, filterTitle):
          return value;
        case this.validateEmail(value):
          return value;

        default:
          return startCase(toLower(value));
      }
    }
  }

  private validateEmail(email: string): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  private isPipeNotApplicable(value: string, filterTitle: ImmutableMonitoringListTitleFilter | string): boolean {
    return (
      Object.values(ImmutableMonitoringListTitleFilter).includes(filterTitle as ImmutableMonitoringListTitleFilter) ||
      isFilterValueUpperCase.includes(value as FilterValueUpperCaseUnionType)
    );
  }

  private isFilterTitleSentenceCase(value: string): boolean {
    return isFilterValueSentenceCase.includes(value as FilterValueSentenceCaseUnionType);
  }

  private isFilterTitleCustomCase(value: string): boolean {
    return !!customFilterTitles[value];
  }

  private isAcronymCustom(value: string): boolean {
    return !!customAcronymTooltips[value];
  }
}
